import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, adminOnly = false, agentOnly = false, customerOnly = false, superAdminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Super Admin access
  if (superAdminOnly && user.role !== 'super_admin') {
    return <Navigate to="/app/home" replace />;
  }

  // Agent access
  if (agentOnly && user.role !== 'agent') {
    return <Navigate to="/app/home" replace />;
  }

  // Customer access
  if (customerOnly && user.role !== 'customer') {
    return <Navigate to="/app/home" replace />;
  }

  // Legacy admin check (for existing admin routes)
  if (adminOnly && user.role !== 'admin' && user.role !== 'super_admin') {
    return <Navigate to="/app/home" replace />;
  }

  return children;
};
